import Client from "../client";
import { resolveCharacterEmote } from "../utils/assetPaths";
import { getThemePlaceholderUrls } from "../webcoa/config";

/**
 * Sets the right sprite <img> source for a character emote, using the
 * authoritative resolver (both (a)/(a)/ prefix forms, desktop ext order,
 * placeholder chain). This is the direct path used by the viewport when
 * a message has no preloaded asset; the normal path goes through
 * preloadMessageAssets + setEmoteFromUrl.
 */
const setEmote = async (
  AO_HOST: string,
  client: Client,
  charactername: string,
  emotename: string,
  prefix: string,
  pair: boolean,
  side: string,
) => {
  const pairID = pair ? "pair" : "char";
  const acceptedPositions = ["def", "pro", "wit"];
  const position = acceptedPositions.includes(side) ? `${side}_` : "";
  const emoteSelector = document.getElementById(
    `client_${position}${pairID}_img`,
  ) as HTMLImageElement;
  if (!emoteSelector) return;

  let placeholders: string[] | undefined;
  try {
    placeholders = getThemePlaceholderUrls();
  } catch {
    placeholders = undefined;
  }

  const url = await resolveCharacterEmote(AO_HOST, charactername, emotename, {
    talking: prefix === "(b)",
    caseFallback: false,
    themePlaceholderUrls: placeholders,
  });
  emoteSelector.src = url;
};
export default setEmote;
